<button
  mat-icon-button
  type="button"
  data-testid="campaign-details-creator-actions-menu-trigger"
  class="!flex items-center justify-center"
  [matMenuTriggerFor]="creatorMenu"
  (click)="$event.stopPropagation()"
  #menuTrigger="matMenuTrigger"
>
  <app-icon src="icons/dots.svg" alt="more options" class="w-4 h-4" />
</button>

<mat-menu #creatorMenu="matMenu" class="creator-actions-menu">
  <button mat-menu-item (click)="onViewCreator($event, menuTrigger)">
    <div class="flex items-center gap-2">
      <span>{{ 'pages.campaignDetails.table.viewCreator' | translate }}</span>
      <app-icon src="/icons/circle-arrow-up-right.svg" alt="View creator" class="w-5 h-5" />
    </div>
  </button>

  @if (briefingNotesMap().get(creator().id) || briefingNotesMap().get(null)) {
    <button mat-menu-item (click)="onViewBriefingNotes($event, menuTrigger)">
      <div class="flex items-center">
        <span>{{ 'pages.campaignDetails.table.creatorCampaignExport.viewBriefingNotes' | translate }}</span>
      </div>
    </button>
  }

  <app-creator-campaign-export
    [campaignId]="campaign()?.id ?? ''"
    [creatorId]="creator().id"
    [creatorName]="creator().name"
    [creatorCampaignExports]="creatorCampaignExports()"
    [viewMode]="viewMode()"
    [currentTab]="currentTab()"
    [menuTrigger]="menuTrigger"
  />
</mat-menu>
